// src/js/config/proceedToOrder.js

import { collectFormData } from './configFormHandler.js';
import { showMessage } from './ui/showMessage.js';
import { getAllOrderConfigs } from './configLoader.js';
import { performSave } from './performSave.js'; // Importerar vår nya centrala spar-funktion

/**
 * Hittar ett unikt namn för en konfiguration genom att lägga till (n) om namnet redan finns.
 */
function getNextUniqueConfigName(baseName) {
    let newName = baseName;
    let counter = 1;
    const existingConfigs = getAllOrderConfigs();

    while (existingConfigs.some(config => config.name.toLowerCase() === newName.toLowerCase())) {
        newName = `${baseName} (${counter})`;
        counter++;
    }
    return newName;
}

/**
 * Huvudfunktion för att gå vidare till beställning.
 */
export function proceedToOrder() {
    const strings = window.SimP_Strings || {};
    const currentConfigData = collectFormData();

    if (!currentConfigData || !currentConfigData.name) {
        showMessage(strings.proceed_warning || 'Ange ett namn för din konfiguration för att fortsätta.', 'warning');
        return;
    }

    const uniqueName = getNextUniqueConfigName(currentConfigData.name);
    const configToSave = { ...currentConfigData, name: uniqueName };

    // Definiera vad som ska hända EFTER att den har sparats
    const afterSaveCallback = () => {
        // Spara namnet på den nyss sparade konfigurationen så att ordersidan kan förvälja den
        localStorage.setItem('selectedConfigOnOrderPage', uniqueName);
        // Omdirigera till ordersidan
        window.location.href = 'order-your-product-package';
    };

    // Anropa den centrala spar-funktionen med vår callback
    performSave(configToSave, afterSaveCallback);
}